var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Fretboard utilities")]),_c('p',[_c('router-link',{attrs:{"to":"/all-notes"}},[_vm._v("All Notes")])],1),_c('p',[_c('router-link',{attrs:{"to":"/major-key"}},[_vm._v("Major Keys")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }